export interface ExportData {
  headers: string[];
  rows: (string | number | boolean | null)[][];
}

export interface ExportOptions {
  filename?: string;
  sheetName?: string;
  delimiter?: string;
  includeHeaders?: boolean;
  dateFormat?: string;
}

export enum ExportFormat {
  PNG = 'png',
  CSV = 'csv',
  XLSX = 'xlsx'
}

export interface ChartExportOptions extends ExportOptions {
  /**
   * Pixel density for PNG export (default: 2)
   * - 1 = standard resolution (smaller file)
   * - 2 = retina display (2x resolution, sharper on high-DPI screens)
   * - 3+ = ultra high resolution (larger file, best for printing)
   * @example pixelRatio: 2 // Good balance of quality and file size
   */
  pixelRatio?: number;
  /**
   * Background color for PNG export (default: '#ffffff')
   * Use 'transparent' for transparent background
   * @example backgroundColor: '#f5f5f5'
   */
  backgroundColor?: string;
  /**
   * ECharts components to exclude from export
   * @example excludeComponents: ['toolbox', 'dataZoom']
   */
  excludeComponents?: string[];
}

export type ExportHandler<T = unknown> = (data: T, options?: ExportOptions) => Promise<void>;
